import styled from 'styled-components'

import { up } from '@Globals/Style/breakpoints'

export const ProductBundleWrapper = styled.section(({ theme }) => `
  margin: ${theme.padding.tablet} 0;
`)

export const ProductBundleHeader = styled.div(({ theme }) => `
  display: flex;
  justify-content: space-between;
  padding: 0 ${theme.padding.phablet};
  width: 100%;

  ${up('mobileStyleThreshold')} {
    padding: 0;
  }
`)

export const ProductBundleTitle = styled.h3(() => `
  font: inherit;
  font-size: .875rem;
  color inherit;
  text-transform: inherit;
`)

export const ProductBundleSavings = styled.aside(() => `
  font-size: .875rem;
`)
